import { api } from './apiClient';
import type { Agent, ListResponse, SingleResponse } from '../types/domain';

/** Fields an admin may change on an agent: Trade Portal sign-in email and access. */
export interface AgentPortalPatch {
  email?: string | null;
  portal_access?: boolean;
}

/** A new agent. The id defaults to one built from the name ("Dave Roberts" -> "dave.roberts"). */
export interface NewAgentInput {
  name: string;
  id?: string;
  email?: string | null;
  brands: string[];
  /** 0..1, e.g. 0.125 for 12.5%. */
  commission_rate: number;
  is_admin: boolean;
  portal_access: boolean;
  zoho_id?: string | null;
}

export const agentService = {
  /** Admin only. Returns the agent and its generated 4-digit mobile-app PIN, shown once. */
  async create(input: NewAgentInput): Promise<{ agent: Agent; pin: string }> {
    const result = await api.post<SingleResponse<Agent> & { pin: string }>('/api/v1/agents', input);
    return { agent: result.data, pin: result.pin };
  },

  async list(): Promise<Agent[]> {
    const result = await api.get<ListResponse<Agent>>('/api/v1/agents');
    return result.data || [];
  },

  async getById(id: string): Promise<Agent> {
    const result = await api.get<SingleResponse<Agent>>(`/api/v1/agents/${id}`);
    return result.data;
  },

  async update(id: string, patch: AgentPortalPatch): Promise<Agent> {
    const result = await api.patch<SingleResponse<Agent>>(`/api/v1/agents/${id}`, patch);
    return result.data;
  },
};
